import { render } from "./ViewCollectorCommissions.vue?vue&type=template&id=69ca7a92&scoped=true"
import script from "./ViewCollectorCommissions.vue?vue&type=script&lang=js"
export * from "./ViewCollectorCommissions.vue?vue&type=script&lang=js"

import "./ViewCollectorCommissions.vue?vue&type=style&index=0&id=69ca7a92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ca7a92"]])

export default __exports__